import { NegativeValueAs } from "../../../../../../../../../../../api/types/fieldConfigurationTypes";
import NumberFormatRadioGroup from "./NumberFormatRadioGroup";

interface Props {
  value: NegativeValueAs | undefined;
  onNegativeValueChanged: (showAs: NegativeValueAs) => void;
}

const negativeValueOptions = [
  { label: "-234,6", value: NegativeValueAs.Minus },
  { label: "(234,6)", value: NegativeValueAs.Parentheses },
];

const NegativeValue = ({ onNegativeValueChanged, value }: Props) => {
  return (
    <NumberFormatRadioGroup
      value={value}
      label="Show negative value as"
      options={negativeValueOptions}
      onValueChanged={onNegativeValueChanged}
    />
  );
};

export default NegativeValue;
